// JavaScript Document

$(function() {
	/*
		NEWS SEARCH FORM
		*/
	var dates = $('.dateFrom, .dateTo'),
		dateOpts = {
			maxDate: '+0d',
			dateFormat: 'dd.mm.yy',
			numberOfMonths: 1,
			showOn: "focus",
			constrainInput: true,
			buttonImageOnly: false,
			changeMonth: true,
			changeYear: true,
			onSelect: function( selectedDate ) {
				var option = $(this).hasClass('dateFrom') ? 'minDate' : 'maxDate',
					instance = $(this).data('datepicker'),
					date = $.datepicker.parseDate(
						instance.settings.dateFormat ||
						$.datepicker._defaults.dateFormat,
						  selectedDate, instance.settings);
				
				if (date==null && option=='minDate') {
					dates.not(this).datepicker('option', option, new Date(0));
				} else if (option=='minDate') {
					date.setTime(date.getTime()+(86400000));
					dates.not(this).datepicker('option', option, date);
				}
				
				if (option=='minDate' && dates.not(this).datepicker('getDate')==null) {
					dates.not(this).datepicker('setDate', date);
					setTimeout( function() {
						dates.not(this).trigger('focus');
					}, 10);
				}
				
				$(this).trigger('change');
			}
		};
		
	dates.each(function() {
		var node = $(this),
			parent = node.closest('.optsContainer'),
			check = function() {
				if (node.val()!='') {
					parent.addClass('hasValue');
				} else {
					parent.removeClass('hasValue');
				}
			};

		node
			.datepicker(dateOpts)
			.attr('readonly', true) /* prevent keyboard from poping up on focus */
			.on('change', function() {
				 check();
			}).on('focus',function() {
				parent.addClass('hasFocus');
			}).on('blur',function() {
				parent.removeClass('hasFocus');
			});
					
		check();
	});
	
	dates.datepicker('option', $.datepicker.regional['de']);
	dates.datepicker('option', 'dateFormat', dateOpts.dateFormat);
});